import { render } from "./Edit25Liquidation1.vue?vue&type=template&id=38554de8"
import script from "./Edit25Liquidation1.vue?vue&type=script&lang=js"
export * from "./Edit25Liquidation1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__